import iMask, { FactoryOpts, InputMask } from 'imask'
import { RefObject, useEffect, useRef } from 'react'

export type MaskOptionsType = FactoryOpts

export const useMask = (
    inputRef: RefObject<HTMLInputElement | null>,
    options?: MaskOptionsType
) => {
    const maskRef = useRef<InputMask>(null)

    useEffect(() => {
        if (options && inputRef.current) {
            maskRef.current = iMask(inputRef.current, options)
        }

        return () => {
            if (maskRef.current) {
                maskRef.current.destroy()
            }
        }
    }, [options])
}
